import settings from './settings.middleware.js'
import themes from './themes.middleware.js';
import user from './user.middleware.js';

export default [
    settings,
    themes,
    user
]